import { useState } from 'react';
import Card from 'components/Layout/Card';
import { getDataFromLocalStorage } from 'utils/helpers';
import AllProfiles from './AllProfiles';
import CampaignManagement from './CampaignManagement';
import PendingRequests from './PendingRequests';
import Websites from './Websites';

const ProfileManagement = () => {
  const [tabType, setTabType] = useState('0');
  const userType = getDataFromLocalStorage('user_type');

  const activeClass = 'p-2 bg-new-car color-white text-16-500';
  const inActiveClass = 'p-2 color-dark-blue text-16-500 pointer';
  return (
    <>
      {['0', '1'].includes(userType) ? (
        <>
          <Card className="d-flex align-items-center p-1 unset-br mb-3">
            <div className="d-flex align-items-center flex-wrap gap-2">
              <div
                className={tabType === '0' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('0');
                }}
              >
                All Profiles
              </div>

              <div
                className={tabType === '1' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('1');
                }}
              >
                Websites
              </div>
              <div
                className={tabType === '2' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('2');
                }}
              >
                Pending Requests
              </div>
              <div
                className={tabType === '3' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('3');
                }}
              >
                Campaign Management
              </div>
            </div>
          </Card>
          {tabType === '0' && <AllProfiles tabType={tabType} />}
          {tabType === '1' && <Websites tabType={tabType} />}
          {tabType === '2' && <PendingRequests tabType={tabType} />}
          {/* {tabType === "1" && <AllProfiles tabType={tabType} />} */}
          {tabType === '3' && <CampaignManagement />}
        </>
      ) : (
        <>
          <Card className="d-flex align-items-center p-1 unset-br mb-3">
            <div className="d-flex align-items-center flex-wrap gap-2">
              <div
                className={tabType === '0' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('0');
                }}
              >
                All Profiles
              </div>

              <div
                className={tabType === '1' ? activeClass : inActiveClass}
                onClick={() => {
                  setTabType('1');
                }}
              >
                Websites
              </div>
            </div>
          </Card>
          {tabType === '0' && <AllProfiles tabType={tabType} />}
          {tabType === '1' && <Websites tabType={tabType} />}
          {/* <AllProfiles tabType={tabType} /> */}
        </>
      )}
    </>
  );
};
export default ProfileManagement;
